export class Booking {
  constructor (params = {}) {
    this.id = params.id ? params.id : null
    this.sequence = params.sequence ? params.sequence : null
    this.checkin = params.checkin ? params.checkin : null
    this.checkout = params.checkout ? params.checkout : null
    this.profile = params.profile ? params.profile : params.profile_id
    this.profileId = params.profile_id ? params.profile_id : null
    this.account = params.account ? params.account : params.account_id
    this.accountId = params.account_id ? params.account_id : null
    this.facility = params.facility ? params.facility : params.facility_id
    this.facilityId = params.facility_id ? params.facility_id : null
    this.editable = params.editable ? params.editable : false
    this.guests = []
  }
}
